import { formatDate } from "../services/receipt.service";
import {
    buildDocDefinition, openPdf, buildCollectionBody, fmtLongDate, fmtINR,
} from "./reportTheme";

export const DailyCollectionPrint = async (fromDate, toDate, logoBase64, sevaCollectionMap) => {
    const { body, grandTotal, count } = buildCollectionBody(sevaCollectionMap, "totalAmount", formatDate);

    return openPdf(
        buildDocDefinition({
            logoBase64,
            title: "Collection Details",
            summary: [
                { label: "Period", value: `${fmtLongDate(fromDate)} – ${fmtLongDate(toDate)}` },
                { label: "Total Receipts", value: count },
                { label: "Total Collection", value: fmtINR(grandTotal), accent: true },
            ],
            body,
        })
    );
};

export default DailyCollectionPrint;